import * as turf from '@turf/turf';

import switzerland from '../data/switzerlandCoordinates.json';
import { lv95ToWgs84ForOneCoordinate } from 'views/add-grid/map/coordinateTransforms';

interface Lv95Coordinate {
  x: number;
  y: number;
}

const isValidLv95Coordinate = (coordinate: unknown): coordinate is Lv95Coordinate => {
  if (!coordinate || typeof coordinate !== 'object') {
    return false;
  }

  const candidate = coordinate as Partial<Lv95Coordinate>;
  return Number.isFinite(candidate.x) && Number.isFinite(candidate.y);
};

// Is analysis area within switzerland
const isWithinSwitzerland = (pPolygonCoordinates: Lv95Coordinate[], pAnalysisAreaType?: string) => {
  if (pAnalysisAreaType === 'canton') {
    return true;
  }

  if (pAnalysisAreaType === 'municipality') {
    return true;
  }

  const validCoordinates = Array.isArray(pPolygonCoordinates) ? pPolygonCoordinates.filter(isValidLv95Coordinate) : [];

  if (validCoordinates.length === 0) {
    return false;
  }

  const wgs84Coordinates = validCoordinates.map((coordinate) =>
    lv95ToWgs84ForOneCoordinate(coordinate.x, coordinate.y)
  );

  const switzerlandPolygon = turf.polygon(switzerland.features[0].geometry.coordinates);

  const closedPolygonCoordinates = [...wgs84Coordinates, wgs84Coordinates[0]];

  for (const coord of closedPolygonCoordinates) {
    const point = turf.point([coord.lng, coord.lat]);
    if (!turf.booleanPointInPolygon(point, switzerlandPolygon)) {
      return false;
    }
  }

  return true;
};

export { isWithinSwitzerland };
